import { gkApi } from './index';

const eventApi = gkApi.injectEndpoints({
  endpoints: (builder) => ({
    listEvents: builder.query({
      query: () => ({
        url: '/event/',
        method: 'get',
        params: { limit: 500 },
      }),
      providesTags: [{ type: 'EVENT_LIST' }],
    }),
    getEvent: builder.query({
      query: (eventId) => ({
        url: `/event/${eventId}/`,
        method: 'get',
      }),
    }),
  }),
});

export const {
  useGetEventQuery,
  useListEventsQuery,
  useLazyListEventsQuery,
} = eventApi;
